import { Outlet, Link, useNavigate } from "react-router-dom";
import styles from './layout.module.css';
import { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faSignOutAlt, faCog, faEnvelope, faUser, faSearch, faBell } from '@fortawesome/free-solid-svg-icons';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Footer from "./Footer";
import axios from 'axios'

const baseURL = `${process.env.REACT_APP_API_URL}`

const Layout = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const accessExpiry = localStorage.getItem('accessExpiry');
    const accessToken = localStorage.getItem('accessToken');
    const [query, setQuery] = useState('');
    const [notifications, setNotifications] = useState([])

    const logoutUser = useCallback (
        () => {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('accessExpiry');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('email');
            localStorage.removeItem('username')
            localStorage.removeItem('userId')
    
            navigate('/login')
        }, [navigate]
    )

    useEffect(() => {
        let intervalId;

        if (accessExpiry) {
            const expiryTimestamp = new Date(accessExpiry).getTime();
            const timeUntillExpire = expiryTimestamp - Date.now();
            if (timeUntillExpire <= 0) {
                logoutUser();
            } else {
                setTimeout(() => {
                    logoutUser();
                }, timeUntillExpire);
            }
        }
        fetchNotifications();
        intervalId = setInterval(fetchNotifications, 1000);

        return () => clearInterval(intervalId);
    }, [accessExpiry, logoutUser]);

    const fetchNotifications = async () => {
        try {
            const response = await axios.get(`${baseURL}/profiles/notification_list/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });
            setNotifications(response.data)

        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    }

    const unreadNotifications = notifications.filter(notification => !notification.is_read).length

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleSearch = () => {
        if (query.trim()) {
            navigate(`/search?query=${encodeURIComponent(query.trim())}`);
        } else {
            alert('Please enter a search query.')
        }
        
    };


    return (
        <>
            <nav className={styles.navBar}>
            <div className={styles.navBarLogo}>
                <Link to='/'><img src="/logo.png" alt="MaidMatch Logo" className={styles.logo} /></Link>
            </div>
                <div className={styles.navBarRight}>
                    <div className={styles.searchContainer}>
                        <input 
                            type="text" 
                            placeholder="Search by Name or Location" 
                            className={styles.searchInput} 
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} onClick={handleSearch} style={{cursor:"pointer", marginLeft: '5px'}}/>

                    </div>
                    <ul className={`${styles.navBarLinks} ${menuOpen ? styles.active : ''}`}>

                        <li>
                            <Link to="/findhousegirl/">Find House Girl</Link>
                        </li>
                        
                        <li>
                            <Link 
                                to="/contact"
                                data-tooltip-content='Contact Us' 
                                data-tooltip-id='contactTooltip'
                            >
                                <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} />
                            </Link>
                            <ReactTooltip 
                                id='contactTooltip' 
                                place='bottom'
                                style={{
                                    backgroundColor: '#1a73e8',
                                    color: '#ffffff',
                                    fontSize: '14px',
                                    padding: '10px',
                                    border: '1px solid #0d47a1',
                                    borderRadius: '4px',
                                    textAlign: 'center',
                                }}
                            />
                        </li>
                        {!accessToken && (
                            <>
                                <li>
                                    <Link to="/register">Register</Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/login"   
                                        data-tooltip-content='Login' 
                                        data-tooltip-id='loginTooltip' 
                                    >
                                        <FontAwesomeIcon icon={faSignInAlt} />
                                    </Link>
                                    <ReactTooltip 
                                        id='loginTooltip' 
                                        place='bottom'
                                        style={{
                                            backgroundColor: '#1a73e8',
                                            color: '#ffffff',
                                            fontSize: '14px',
                                            padding: '10px',
                                            border: '1px solid #0d47a1',
                                            borderRadius: '4px',
                                            textAlign: 'center',
                                        }}
                                    />
                                </li>
                            </>
                        )} {accessToken && (
                            <>
                                <li>
                                    <Link 
                                        to="/profile"
                                        data-tooltip-content='Profile' 
                                        data-tooltip-id='userTooltip' 
                                    >
                                        <FontAwesomeIcon icon={faUser} style={{ marginRight: '8px' }} />
                                    </Link>
                                    <ReactTooltip 
                                        id='userTooltip' 
                                        place='bottom'
                                        style={{
                                            backgroundColor: '#1a73e8',
                                            color: '#ffffff',
                                            fontSize: '14px',
                                            padding: '10px',
                                            border: '1px solid #0d47a1',
                                            borderRadius: '4px',
                                            textAlign: 'center',
                                        }}
                                    />
                                </li>
                                <li>
                                    <Link 
                                        to="/settings"
                                        data-tooltip-content='Settings' 
                                        data-tooltip-id='settingsTooltip' 
                                    >
                                        <FontAwesomeIcon icon={faCog} style={{ marginRight: '8px' }} />
                                    </Link>
                                    <ReactTooltip 
                                        id='settingsTooltip' 
                                        place='bottom'
                                        style={{
                                            backgroundColor: '#1a73e8',
                                            color: '#ffffff',
                                            fontSize: '14px',
                                            padding: '10px',
                                            border: '1px solid #0d47a1',
                                            borderRadius: '4px',
                                            textAlign: 'center',
                                        }}
                                    />
                                </li>
                                <li className="nav-item">
                                    <Link 
                                        to='/notifications/'
                                        data-tooltip-content="Notifications"
                                        data-tooltip-id="notificationTooltip"
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <FontAwesomeIcon icon={faBell} />
                                            {unreadNotifications > 0 && (
                                                <span className="notification-badge" style={{
                                                    color: 'white',
                                                    backgroundColor: 'red',
                                                    borderRadius: '50%',
                                                    padding: '4px 8px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    top: '-10px',
                                                    right: '-15px',
                                                    position: 'absolute',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >{unreadNotifications}
                                                </span>
                                            )}
                                    </Link>
                                </li>
                                <ReactTooltip 
                                    id="notificationTooltip" 
                                    place="bottom" 
                                    style={{
                                        backgroundColor: '#4caf50',
                                        color: '#ffffff',
                                        fontSize: '14px',
                                        padding: '10px',
                                        border: '1px solid #388e3c',
                                        borderRadius: '4px',
                                        textAlign: 'center',
                                    }}
                                />

                                <span 
                                    onClick={logoutUser} 
                                    className={styles.logoutButton}
                                    data-tooltip-content="Logout"
                                    data-tooltip-id="logoutTooltip"
                                >
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                </span>
                                <ReactTooltip 
                                    id="logoutTooltip" 
                                    place="bottom" 
                                    style={{
                                        backgroundColor: '#ff4d4f',
                                        color: '#ffffff',
                                        fontSize: '14px',
                                        padding: '10px',
                                        border: '1px solid #d32f2f',
                                        borderRadius: '4px',
                                        textAlign: 'center',
                                    }}
                                />
                                
                            </>
                        )}
                        
                        

                    </ul>
                </div>
                <button className={styles.navBarToggle} onClick={toggleMenu}>
                    <span className={styles.navBarToggleBar}></span>
                    <span className={styles.navBarToggleBar}></span>
                    <span className={styles.navBarToggleBar}></span>
                </button>
            </nav>
            <div
                className={styles.contentWrapper}
                style={{ marginTop: menuOpen ? '150px' : '10px' }}
            >
                <div style={{minHeight: '100vh'}}>
                    <Outlet />
                </div>
                <Footer />
            </div>
        </>
    );
};

export default Layout;
